import React from "react";
import { useDispatch, useSelector } from "react-redux";
import { useEffect, useState, useMemo } from "react";
import { DateRangePicker, Stack } from "rsuite";
import subDays from "date-fns/subDays";
import startOfWeek from "date-fns/startOfWeek";
import endOfWeek from "date-fns/endOfWeek";
import addDays from "date-fns/addDays";
import "rsuite/dist/rsuite.css";
import isAfter from "date-fns/isAfter";
import {
  setUserOptionDashboardEmployeesActions,
  setThefinanceDataExportActions,
  setGeoLoactionStateAction,
  setZoneActions,
  setRegionActions,
  getSideBarfilesActions,
  setClientBranchActions,
  SetTheDashboardClientList,
  setaRoleChnage,
  setClientBranchSearchAction,
  seTheWhiteCollor,
  seTheWhiteCollar_objects,
  setTheZoneObjects,
  settheStateObjects,
  setTheregionsObjects,
} from "../../../Redux/Slice";
import ReactTable from "../../AppComponent/Table";
import profile2 from "../../../Assets/AppComponent/Profile/profile2.png";
import GetAppIcon from "@material-ui/icons/GetApp";
import Select from "react-select";
import { NavLink, useNavigate } from "react-router-dom";
import { UserEdit } from "../../../text/apidata";
import _ from "lodash";

import BackImage from "../../../Assets/AppComponent/Overall_icons/UDS Needs Image-20.svg";
import useDebouncedEffect from 'use-debounced-effect';

const UserEmployeeList = () => {
  const dispatch = useDispatch();
  const stateDisplay = useSelector(
    (state) => state.SideBarActive.SidebarActive
  );
  const navigate = useNavigate();
  const [dtpageindex, setdtPageindex] = useState(1);
  const [dtpagesize, setdtPagesize] = useState(20);
  const [pageSize, setPageSize] = useState(20);
  const [currentPage, setCurrentPage] = useState(1);
  const [search, setsearch] = useState("");
  const state = useSelector((state) => state);
  // console.log(state.EmployeeVerificationsNeed, "EmployeeVerificationsNeed");
  const [multiselect, setMuliselect] = useState(
    state.EmployeeVerificationsNeed.StateObjects
  );
  const [sno, setsno] = useState(0);

  let [nameList, setOptions] = useState([]);
  const [nameList2, setOptions2] = useState([]);
  const [REgion, setRegion] = useState([]);
  const [multiselect1, setMuliselect1] = useState(
    state.EmployeeVerificationsNeed.RegionObjects
  );
  const [multiselect3, setMuliselect3] = useState(
    state.EmployeeVerificationsNeed.ZoneObjects
  );
  // console.log(state.EmployeeVerificationsNeed.ZoneObjects, "ZoneObjects");
  const [nameList4, setOptions4] = useState([]);
  const [Zone, setZone] = useState([]);
  const [clientname, setClientName] = useState("ALL");

  const [data, setData] = useState({
    zone: state.EmployeeVerificationsNeed.ZoneObjects.value,
    state: state.EmployeeVerificationsNeed.StateObjects.value,
    region: state.EmployeeVerificationsNeed.RegionObjects.value,
  });
  const initialStateSearch = {
    stateSearch: "",
    regionSearch: "",
    zoneSearch: "",
  };
  const [SearchedVal, setSearched] = useState(initialStateSearch);
  const initialDebouanceSearch = {
    stateSearch: "",
    regionSearch: "",
    zoneSearch: "",
};

const [SearchDebounance, setSearchDebounance] = useState(initialDebouanceSearch);

  const [searchBranch, setSearch] = useState("");
  const [nameList5, setOptions5] = useState([]);
  const [Client, setClients] = useState();

  const [Perecentagedata, setPercentageData] = useState({
    ///---counts  fro the  employees
    aadhar_count: 4,
    bank_count: 2,
    pan_count: 4,
    whats_app_amount: 2,
  });

  const [EmpRoles, setEmplyeRole] = useState([
    {
      value: "",
      label: "ALL",
    },
    {
      value: "1",
      label: "UDS",
    },
    {
      value: "2",
      label: "CLIENT",
    },
  ]);
  console.log(
    state.EmployeeVerificationsNeed.SetTheWhiteObjects,
    "WhiteCollar"
  );
  // const [EMpROleSelected, setEmpRoleSele] = useState(EmpRoles[0]);
  const [filterForWhite, setFilters] = useState({
    white_collar:
      state.EmployeeVerificationsNeed.SetTheWhiteObjects.value == 1
        ? true
        : state.EmployeeVerificationsNeed.SetTheWhiteObjects == 2
        ? false
        : "",
  });
  const [EMpROleSelected, setEmpRoleSele] = useState(
    state.EmployeeVerificationsNeed.SetTheWhiteObjects
  );

  //   useEffect(() => {
  //     dispatch(SetTheDashboardClientList({ value: "", label: "All" }));
  // console.log(state.EmployeeVerificationsNeed , "SetTheWhiteObjects");
  //   }, []);

  const HandleClientBranches = (selectedVal) => {
    dispatch(SetTheDashboardClientList(selectedVal));
    if (selectedVal != null) {
      setClients(selectedVal.value);
      setClientName(selectedVal.label);
    } else {
      dispatch(SetTheDashboardClientList({ value: "", label: "ALL" }));
      setClients("");
    }
  };
  const HandleEMprole = (e) => {
    if (e != null) {
      setEmpRoleSele(e);
      dispatch(seTheWhiteCollar_objects(e));
      if (e.value == 1) {
        dispatch(setaRoleChnage(1));
        setFilters({
          ...filterForWhite,
          white_collar: true,
        });

        dispatch(SetTheDashboardClientList({ value: "", label: "ALL" }));
        setClients("");

        dispatch(SetTheDashboardClientList({ value: "", label: "ALL" }));
        setClients("");
        dispatch(seTheWhiteCollor(true));
      } else if (e.value == 2) {
        dispatch(setaRoleChnage(2)); ///Role based dispatch for the white_collar
        setFilters({
          ...filterForWhite,
          white_collar: false,
        });
        dispatch(seTheWhiteCollor(false));
      }
    }
  };

  const HandleInputBranch = (e) => {
    setSearch(e);
  };
  useEffect(() => {
    if (state.ClientBranch.ClientBranchess != undefined) {
      let objectArray = [];
      objectArray.push({ value: "", label: "ALL" });
      state.ClientBranch.ClientBranchess.forEach((element) => {
        objectArray.push({
          value: element.id,
          label: element.client_name,
        });
      });
      setOptions4(objectArray);
    }
  }, [state.ClientBranch.ClientBranchess, searchBranch]);

  ///---Branches------------------------------
  useEffect(() => {
    const payload = {
      search: searchBranch,
      page_size: 50,
      page: 1,
      data: data,
    };
    dispatch(setClientBranchSearchAction(payload));
  }, [searchBranch, data]);
  useDebouncedEffect(
    () => {
        if (setSearchDebounance) {
            setSearched({
                ...SearchedVal,
                stateSearch: SearchDebounance.stateSearch,
                regionSearch: SearchDebounance.regionSearch,
                zoneSearch: SearchDebounance.zoneSearch,
            });

        }
    },
    500,
    [SearchDebounance]
);


  ///-----State----Input Changes
  const handleInputChange = (Val) => {
    setSearchDebounance({
        ...SearchDebounance,
        stateSearch: Val,

    });

};

///---Region-----------------
const handleInputRegion = (Val) => {
    setSearchDebounance({
        ...SearchDebounance,
        regionSearch: Val,
    });
};
///----Zone---Name
const handleInputZone = (Val) => {
    setSearchDebounance({
        ...SearchDebounance,
        zoneSearch: Val,
    });
};

  var today = new Date();
  var priorDate = new Date(new Date().setDate(today.getDate() - 30));
  var it = convert(today);
  var gt = convert(today);

  // console.log(it, gt);
  // state.EmployeeVerificationsNeed.FROMDATE,
  // state.EmployeeVerificationsNeed.TODATE,

  var st = convert(state.EmployeeVerificationsNeed.AttendanceFROMDATE);
  var et = convert(state.EmployeeVerificationsNeed.AttendanceTODATE);

  const [range, setrange] = useState(
    state.EmployeeVerificationsNeed.AttendanceFROMDATE == ""
      ? [it, gt]
      : [st, et]
  );

  const formattedDates = [gt, it].map((dateString) => {
    const dateObject = new Date(dateString);
    return dateObject.toString();
  });

  // console.log([gt, it] ,    [new Date(new Date().setDate(today.getDate() - 30)),
  //   new Date()],

  // "formattedDates", [                  new Date(state.EmployeeVerificationsNeed.FROMDATE),
  //   new Date(state.EmployeeVerificationsNeed.TODATE)]);

  function convert(str) {
    var date = new Date(str),
      mnth = ("0" + (date.getMonth() + 1)).slice(-2),
      day = ("0" + date.getDate()).slice(-2);
    return [date.getFullYear(), mnth, day].join("-");
  }

  //----Handle----Date=-----Changes---
  const handlechangedate = (value) => {
    if (value != null) {
      setrange((oldArray) => [...oldArray, value.slice(0, 10)]);
    }
  };

  const cleaningrange = () => {
    //setrange([gt,it]);
  };

  const pagesize = (arg) => {
    setdtPagesize(arg);
  };
  const pageindex = (arg) => {
    //  console.log(arg, "args");
    setdtPageindex(arg);
  };

  const predefinedBottomRanges = [
    {
      label: "Today",
      value: [new Date(), new Date()],
      placement: "left",
    },
    {
      label: "Yesterday",
      value: [addDays(new Date(), -1), addDays(new Date(), -1)],
      placement: "left",
    },
    {
      label: "This week",
      value: [startOfWeek(new Date()), endOfWeek(new Date())],
      placement: "left",
    },
    {
      label: "Last week",
      value: (value, index) => {
        const [start = new Date()] = value[index] || [];
        return [
          addDays(startOfWeek(start, { weekStartsOn: 0 }), -7),
          addDays(endOfWeek(start, { weekStartsOn: 0 }), -7),
        ];
      },
      placement: "left",
    },
    {
      label: "Last 30 days",
      value: [subDays(new Date(), 29), new Date()],
      placement: "left",
    },
  ];
  const debouncedSearch = useMemo(
    () =>
      _.debounce((e) => {

        setsearch(e);
      }, 500),
    []
  );
  function tochange(e) {
    // setsearch(e);
    setdtPageindex(1);
    debouncedSearch(e);

  }
  React.useEffect(() => {
    return () => {
      debouncedSearch.cancel();
    };
  }, [debouncedSearch]);

  ///--------------State-----------------
  useEffect(() => {
    const payloads = {
      search: SearchedVal.stateSearch,
      page_size: "",
      page: 1,
    };
    dispatch(setGeoLoactionStateAction(payloads));
  }, [SearchedVal.stateSearch]);
  //--------------_Zone---------------
  useEffect(() => {
    const payloads = {
      search: SearchedVal.zoneSearch,
      page_size: 20,
      page: 1,
      counts: 1,
      region_id: data.region,
    };
    dispatch(setZoneActions(payloads));
    setZone(state.ZonePart.Zone);
  }, [data.region, SearchedVal.zoneSearch]);

  //-----Region---------
  useEffect(() => {
    const payloads = {
      search: SearchedVal.regionSearch,
      page_size: 20,
      page: 1,
      counts: 1, //-----only we ----get----the----selected regions , the--id only
      state: data.state,
    };
    dispatch(setRegionActions(payloads));
    //console.log(State.regioncall.RegionDat, "states", State.regioncall.Total_Count);
    setRegion(state.regioncall.RegionDat);
  }, [data.state, SearchedVal.regionSearch]);

  // const handleSelectChange = (selectedVal) => {
  //   if (selectedVal != null) {
  //     setMuliselect(selectedVal);
  //     setData({
  //       ...data,
  //       state: selectedVal.value,
  //     });
  //   }
  //   if (selectedVal == null) {
  //     setMuliselect({ value: "", label: "All" });
  //     setMuliselect1({ value: "", label: "All" });
  //     setMuliselect3({ value: "", label: "All" });
  //     setData({
  //       ...data,
  //       state: "",
  //       region: "",
  //       zone: "",
  //     });
  //   }
  // };

  useEffect(() => {
    if (state.FinanceGetListedData.FinanceDatasCounts) {
      const optionsDatas = {
        aadhar_count:
          state.FinanceGetListedData.FinanceDatasCounts.aadhar_count,
        bank_count: state.FinanceGetListedData.FinanceDatasCounts.bank_count,
        pan_count: state.FinanceGetListedData.FinanceDatasCounts.pan_count,

        whats_app_amount:
          state.FinanceGetListedData.FinanceDatasCounts.whats_app_amount,
      };

      setPercentageData(optionsDatas);
    }
  }, [state.FinanceGetListedData.FinanceDatasCounts]);
  useEffect(() => {
    if (state.GeoState.State != undefined) {
      let objectArray = [];
      objectArray.push({ value: "", label: "ALL" });

      state.GeoState.State.forEach((element) => {
        objectArray.push({ value: element.id, label: element.state_name });
      });

      setOptions(objectArray);
    }
  }, [state.GeoState.State, SearchedVal.stateSearch]);
  ///  ///----------------------REgion-----------
  useEffect(() => {
    setRegion(state.regioncall.RegionDat);
    if (state.regioncall.RegionDat != undefined) {
      let objectArray = [];
      objectArray.push({ value: "", label: "ALL" });

      state.regioncall.RegionDat.forEach((element) => {
        objectArray.push({
          value: element.id,
          label: element.region_name.toUpperCase(),
        });
      });

      setOptions2(objectArray);
    }
  }, [state.regioncall.RegionDat, SearchedVal.regionSearch]);

  ///-------------Zone--------------
  useEffect(() => {
    const Datas = [];

    if (state.ZonePart.Zone != undefined) {
      let objectArray = [];
      objectArray.push({ value: "", label: "ALL" });
      state.ZonePart.Zone.forEach((element) => {
        objectArray.push({
          value: element.id,
          label: element.zone_name.toUpperCase(),
        });
      });
      setOptions5(objectArray);
    }
  }, [state.ZonePart.Zone, SearchedVal.zoneSearch]);

  // //----Region----------------
  // const handelRegionSlect = (selectedVal) => {
  //   if (selectedVal != null) {
  //     setMuliselect1(selectedVal);
  //     setData({
  //       ...data,
  //       region: selectedVal.value,
  //     });
  //   }
  //   if (selectedVal == null && data.state == null && data.zone == null) {
  //     setData({
  //       ...data,
  //       region: "",
  //     });
  //     const payload = {
  //       search: "",
  //       page_size: dtpagesize,
  //       page: dtpageindex,
  //     };
  //   }
  //   if (selectedVal == null) {
  //     setMuliselect1({ value: "", label: "All" });
  //     setMuliselect3({ value: "", label: "All" });
  //     setData({
  //       ...data,
  //       region: "",
  //       zone: "",
  //     });
  //   }
  // };
  // //----------------Zone
  // const handleZone = (selectedVal) => {
  //   if (selectedVal != null) {
  //     setMuliselect3(selectedVal);
  //     setData({
  //       ...data,
  //       zone: selectedVal.value,
  //     });
  //   }
  //   if (selectedVal == null && data.region == null && data.state == null) {
  //     setData({
  //       ...data,
  //       zone: "",
  //     });
  //   }
  // };

  //----Region----------------
  const handelRegionSlect = (selectedVal) => {
    if (selectedVal != null) {
      setMuliselect1(selectedVal);
      setMuliselect3({ value: "", label: "ALL" });
      dispatch(setTheregionsObjects(selectedVal));
      dispatch(setTheZoneObjects({ value: "", label: "ALL" }));

      setData({
        ...data,
        region: selectedVal.value,
      });
    }
    if (selectedVal == null) {
      setData({
        ...data,
        region: "",
        zone: "",
      });

      dispatch(setTheregionsObjects({ value: "", label: "ALL" }));
      dispatch(setTheZoneObjects({ value: "", label: "ALL" }));

      setMuliselect3({ value: "", label: "ALL" });

      setMuliselect1({ value: "", label: "ALL" });
    }
  };
  //----------------Zone
  const handleZone = (selectedVal) => {
    //console.log(selectedVal ,"selected Values");
    if (selectedVal != null) {
      setMuliselect3(selectedVal);
      setData({
        ...data,
        zone: selectedVal.value,
      });

      dispatch(setTheZoneObjects(selectedVal));
    }
    if (selectedVal == null) {
      setData({
        ...data,
        zone: "",
      });
      dispatch(setTheZoneObjects({ value: "", label: "ALL" }));

      setMuliselect3({ value: "", label: "ALL" });
    }
  };
  const handleSelectChange = (selectedVal) => {
    if (selectedVal != null) {
      setMuliselect(selectedVal);
      setMuliselect1({ value: "", label: "ALL" });
      setMuliselect3({ value: "", label: "ALL" });

      setData({
        ...data,
        state: selectedVal.value,
        zone: "",
        region: "",
      });

      dispatch(settheStateObjects(selectedVal));
      dispatch(setTheregionsObjects({ value: "", label: "ALL" }));

      dispatch(setTheZoneObjects({ value: "", label: "ALL" }));
    }
    if (selectedVal == null) {
      setMuliselect({ value: "", label: "ALL" });
      setMuliselect1({ value: "", label: "ALL" });
      setMuliselect3({ value: "", label: "ALL" });
      setData({
        ...data,
        state: "",
        zone: "",
        region: "",
      });

      dispatch(settheStateObjects({ value: "", label: "ALL" }));
      dispatch(setTheregionsObjects({ value: "", label: "ALL" }));

      dispatch(setTheZoneObjects({ value: "", label: "ALL" }));
    }
  };

  useEffect(() => {
    if (state.BranchSearchpart.BranchSearch != undefined) {
      let objectArray = [];
      objectArray.push({ value: "", label: "ALL" });
      state.BranchSearchpart.BranchSearch.forEach((element) => {
        objectArray.push({
          value: element.id,
          label: element.client_name,
        });
      });
      setOptions4(objectArray);
    }
  }, [state.BranchSearchpart.BranchSearch, search]);

  const capitalizeFirstLetter = (Letter) => {
    return Letter.charAt(0).toUpperCase() + Letter.slice(1);
  };



  useEffect(() => {
    const payload = {
      search: search,
      page_size: 20,
      page: dtpageindex,
      from_date: range[0],
      to_date: range[1],
      range: false,
      state: data.state,
      region: data.region,
      zone: data.zone,
      client: state.DashboardCall.DashboardCLientList.value,
      //   return_type: state.EmployeeVerificationsNeed.AttendanceDashboardStatus,
      // white_collar: filterForWhite.white_collar,
      white_collar: state.EmployeeVerificationsNeed.WhiteCollar,
    };
    dispatch(setUserOptionDashboardEmployeesActions(payload))
  }, [data, dtpageindex, search ,state.DashboardCall.DashboardCLientList , state.EmployeeVerificationsNeed.WhiteCollar]);



  const handleNext = (next) => {
    setdtPageindex(next + 1);
  };
  const GotoEnteredPage = (gotopage) => {
    setdtPageindex(gotopage);
  };
  const handlePrevious = (previous) => {
    if (previous != 0) {
      setdtPageindex(previous);
    }
  };

  function maxword(data) {
    const maxLength = 7; // Set your desired maximum length
    const ellipsis = "..."; // Set your ellipsis string

    return data.length > maxLength
      ? `${data.substring(0, maxLength)}${ellipsis}`
      : data;
  }

  const truncateText = (text, maxLength) => {
    if (text.length <= maxLength) {
      return text;
    }
    return text.substring(0, maxLength) + "...";
  };

  const columns = useMemo(
    () => [
      {
        Header: "Tnx Id",
        accessor: "",
        Cell: (row) => {
          if (row.row.original.id != undefined && row.row.original.id != null) {
            const userId = row.row.original.id;
            const lastFourDigits = userId.slice(-6);

            return <p>{lastFourDigits}</p>;
          }
        },
      },

      {
        Header: filterForWhite.white_collar ? "Name" : "Employee Name",
        accessor: "",

        Cell: (row) => {
          const [showTooltip, setShowTooltip] = useState(false);

          return (
            <>
              {row.row.original.first_name != undefined &&
              row.row.original.first_name != null ? (
                <>
                  <div
                    className="UserName"
                    onMouseEnter={() => setShowTooltip(true)}
                    onMouseLeave={() => setShowTooltip(false)}
                    style={{ position: "relative" }}
                  >
                    <span

                    >
                      {row.row.original.first_name.length > 10 ? (
                        <>
                          {capitalizeFirstLetter(
                            row.row.original.first_name.slice(0, 9)
                          )}
                          ...
                        </>
                      ) : (
                        <>
                          {capitalizeFirstLetter(row.row.original.first_name)}
                        </>
                      )}
                    </span>
                    {showTooltip && (
                      <div className="custom-tooltip">
                        {row.row.original.first_name}
                      </div>
                    )}
                  </div>
                </>
              ) : (
                <span>{"--"}</span>
              )}
            </>
          );
        },
      },
      // {
      //   Header: "Email",
      //   accessor: "",
      //   Cell: (row) => {
      //     return (
      //       <>
      //         {row.row.original.email != undefined && row.row.original.email != undefined  ? (
      //           <span>{row.row.original.email}</span>
      //         ) : (
      //           <span>{"--"}</span>
      //         )}
      //       </>
      //     );
      //   },
      // },

      {
        Header: "Email",
        accessor: "",
        Cell: (row) => {
          const [showTooltip, setShowTooltip] = useState(false);

          return (
            <>
              {row.row.original.email != "" &&
              row.row.original.email != undefined &&
              row.row.original.email != undefined &&
              row.row.original != undefined ? (
                <div
                  className="UserName"
                  onMouseEnter={() => setShowTooltip(true)}
                  onMouseLeave={() => setShowTooltip(false)}
                  style={{ position: "relative" }} // Relative positioning for tooltip placement
                >
                  <span>
                    {row.row.original.email.length > 10 ? (
                      <>{row.row.original.email.slice(0, 9)}...</>
                    ) : (
                      <>{row.row.original.email}</>
                    )}
                  </span>
                  {showTooltip && (
                    <div className="custom-tooltip">
                      {row.row.original.email}
                    </div>
                  )}
                </div>
              ) : (
                <span>{"--"}</span>
              )}
            </>
          );
        },
      },

      // {
      //   Header: "Designation",
      //   accessor: "",
      //   Cell: (row) => {
      //     const [showTooltip, setShowTooltip] = useState(false);
  
      //     return (
      //       <>
      //         <span>
      //           {row.row.original.user_id.user_role.role != null &&
      //           row.row.original.user_id.user_role.role != undefined &&
      //           row.row.original.user_id.user_role.role != "" ? (
      //             <div className="UserName"
      //             onMouseEnter={() => setShowTooltip(true)}
      //             onMouseLeave={() => setShowTooltip(false)}
      //             style={{ position: 'relative' }} 
      //           >
  
      //             <>
      //               {
      //               row.row.original.role.length > 10 ? (
      //                 truncateText(row.row.original.role, 10)
      //               ) :
      //                (
      //                 <>{row.row.original.user_id.user_role.role}</>
      //               )}
      //             </>
      //             {showTooltip && (
      //                   <div className="custom-tooltip">
      //                     {row.row.original.user_id.user_role.role}
      //                   </div>
      //                 )}
  
      //             </div>
      //           ) : (
      //             <span>{"---"} </span>
      //           )}
      //         </span>
      //       </>
      //     );
      //   },
      // },
      {
        Header: "Designation",
        accessor: "",
        Cell: (row) => {
          const [showTooltip, setShowTooltip] = useState(false);
  
          return (
            <>
              <span>
                {row.row.original.user_role.role != null &&
                row.row.original.user_role.role != undefined &&
                row.row.original.user_role.role != "" ? (
                  <div className="UserName"
                  onMouseEnter={() => setShowTooltip(true)}
                  onMouseLeave={() => setShowTooltip(false)}
                  style={{ position: 'relative' }} 
                >
  
                  <>
                    {
                    row.row.original.user_role.role.length > 10 ? (
                      truncateText(row.row.original.user_role.role, 10)
                    ) :
                     (
                      <>{row.row.original.user_role.role}</>
                    )}
                  </>
                  {showTooltip && (
                        <div className="custom-tooltip">
                          {row.row.original.user_role.role}
                        </div>
                      )}
  
                  </div>
                ) : (
                  <span>{"---"} </span>
                )}
              </span>
            </>
          );
        },
      },
      {
        Header: "Phone Number",
        accessor: "",
        Cell: (row) => {
          return (
            <>
              {row.row.original.phone_number != undefined ? (
                <span>{row.row.original.phone_number}</span>
              ) : (
                <span>{"--"}</span>
              )}
            </>
          );
        },
      },

      // {
      //   Header: "Kyc Role",
      //   accessor: "",
      //   Cell: (row) => {
      //     return (
      //       <>
      //         {row.row.original.sub_role != undefined ? (
      //           <>
      //             {row.row.original.sub_role == "0" ? (
      //               <span>{"PAYROLL"}</span>
      //             ) : (
      //               <>
      //                 {row.row.original.sub_role == "1" ? (
      //                   <span>{"REGIONAL MANAGER"}</span>
      //                 ) : (
      //                   <>
      //                     {row.row.original.sub_role == "2" ? (
      //                       <span>{"ONBOARDER"}</span>
      //                     ) : (
      //                       <>
      //                         {row.row.original.sub_role == "3" ? (
      //                           <span>{"SUPER ADMIN"}</span>
      //                         ) : (
      //                           <>
      //                             {row.row.original.sub_role == "4" ? (
      //                               <span>{"SUPERVIORS"}</span>
      //                             ) : (
      //                               <span>{"--"}</span>
      //                             )}
      //                           </>
      //                         )}
      //                       </>
      //                     )}
      //                   </>
      //                 )}
      //               </>
      //             )}
      //           </>
      //         ) : (
      //           <span>{"--"}</span>
      //         )}
      //       </>
      //     );
      //   },
      // },

      {
        Header: "Created Date",
        accessor: "",
        Cell: (row) => {
          const dateString = row.row.original.created_at;
          const dateObject = new Date(dateString);
          const hours = dateObject.getHours();
          const minutes = dateObject.getMinutes();
          const seconds = dateObject.getSeconds();
          const amOrPm = hours >= 12 ? "PM" : "AM";
          const twelveHourFormat = hours % 12 || 12;

          const formattedMinutes = minutes < 10 ? `0${minutes}` : minutes;

          const formattedTime = `${twelveHourFormat}:${formattedMinutes} ${amOrPm}`;

          return (
            <>
              <span
              >
                {`${
                  row.row.original.created_at.slice(0, 10)

                  // +
                  // "  " +
                  // formattedTime
                }`}
              </span>
            </>
          );
        },
      },
    ],
    [sno]
  );

  return (
    <>
      <div className={stateDisplay ? "outterContent" : "inner-Content"}>
        <div
          className="Header-Details ClientBranch row"
          style={{ padding: "14px 28px" }}
        >
          <div
            class="col-sm-7 auto"
            style={{
              display: "flex",
              flexDirection: "column",
              alignItems: "flex-start",
              justifyContent: "flex-start",
            }}
          >
            <h2>Employee List Report</h2>
          </div>
        </div>
        <div
          className="row Filters ButtonPrevious"
          style={{
            padding: "15px 28px",
            margin: "0px",
            position: "relative",
            zIndex: "30",
            marginLeft: "0px",
            marginRight: "0px",
            top: "-30px",
          }}
        >
          <div className="col">
            <button
              className="btn BackImga"
              onClick={(e) => {
                navigate("/attendances");
              }}
            >
              <img className="PreviousPages" src={BackImage} />
              <span></span>
            </button>
          </div>
        </div>

        <div
          className=" row FilterManagement"
          style={{
            padding: "15px 28px",
            margin: "0px",
            position: "relative",
            zIndex: "30",
            marginTop: "20px",

            marginLeft: "0px",
            marginRight: "0px",
            top: "-30px",
          }}
        >
          <div
            className="col-sm-2"
            style={{ marginTop: "-19px", zIndex: "99" }}
          >
            <label
              for="validationCustom01"
              class="form-label"
              style={{ fontSize: "19px" }}
            >
              State
            </label>
            <Select
              className="Selects"
              styles={{ position: "relative", top: "60px" }}
              // options={options}
              // onChange={handleChange}
              onSelect={(e) => {
                setMuliselect(e);
              }}
              onChange={(e) => {
                handleSelectChange(e);
              }}
              options={nameList}
              onInputChange={handleInputChange}
              onremoved={(e) => {
                setMuliselect(e);
                console.log(e, "jjk9090");
              }}
              value={multiselect}
              labelledBy="Select"
              // placeholder={"Search"}
            />
          </div>

          <div className="col-sm-2" style={{ marginTop: "-19px" }}>
            <label
              for="validationCustom01"
              class="form-label"
              style={{ fontSize: "19px" }}
            >
              Region
            </label>
            <Select
              className="Selects"
              styles={{ position: "relative", top: "60px" }}
              // options={options}
              // onChange={handleChange}
              onSelect={(e) => setMuliselect1(e)}
              onChange={(e) => {
                handelRegionSlect(e);
              }}
              options={nameList2}
              labelledBy="Select"
              isClearable={true}
              onremoved={(e) => {
                setMuliselect1(e);
              }}
              value={multiselect1}
              onInputChange={handleInputRegion}
              // placeholder={
              //   datas.state == ""
              //     ? "without selected state you can't select Region"
              //     : "search"
              // }
            />
          </div>

          <div className="col-sm-2" style={{ marginTop: "-19px" }}>
            <label
              for="validationCustom01"
              class="form-label"
              style={{ fontSize: "19px" }}
            >
              Zone
            </label>
            <Select
              className="Selects"
              styles={{ position: "relative", top: "60px" }}
              // options={options}
              // onChange={handleChange}
              onSelect={(e) => setMuliselect3(e)}
              onChange={(e) => {
                handleZone(e);
              }}
              value={multiselect3}
              options={nameList5}
              isClearable={true}
              onremoved={(e) => {
                setMuliselect3(e);
                console.log(e, "jjk9090");
              }}
              labelledBy="Select"
              onInputChange={handleInputZone}
            />
          </div>
          {/* <div
            className="col-sm-2"
            style={{ zIndex: "20", marginTop: "-19px" }}
          >
            <label
              for="validationCustom01"
              class="form-label"
              style={{ fontSize: "19px" }}
            >
              Branch Name
            </label>
            <Select
              className="Selects"
              styles={{ position: "relative", top: "60px" }}
              onSelect={(e) => {
                dispatch(SetTheDashboardClientList(e));
              }}
              onChange={(e) => {
                HandleClientBranches(e);
              }}
              isDisabled
              options={nameList4}
              labelledBy="Select"
              onInputChange={HandleInputBranch}
              isClearable={true}
              // isMulti
              //  isDisabled={filterForWhite.white_collar ? true : false}
              value={state.DashboardCall.DashboardCLientList}
            />
          </div>

          <div
            class=" field-div col-sm-2"
            style={{ zIndex: "20", marginTop: "-19px" }}
          >
            <label
              for="validationCustom02"
              class="form-label FilterLabel"
              // style={{ fontSize: "15px" }}
            >
              Employee Designation
            </label>

            <Select
              className="Selects"
              styles={{ position: "relative", top: "60px" }}
              onChange={(e) => {
                HandleEMprole(e);
              }}
              isDisabled
              value={EMpROleSelected}
              options={EmpRoles}
              placeholder="search"
            />
          </div> */}

          {/* <div
            className="col-sm-2"
            style={{ zIndex: "20", marginLeft: "-10px" }}
          >
            <div className="datepicker_dash">
              <DateRangePicker
                // defaultValue={[
                //   new Date(new Date().setDate(today.getDate() - 30)),
                //   new Date(),
                // ]}
                defaultValue={[
                  new Date(state.EmployeeVerificationsNeed.FROMDATE),
                  new Date(state.EmployeeVerificationsNeed.TODATE),
                ]}
                disabledDate={(date) => isAfter(date, new Date())}
                editable={false}
                isDisabled
                appearance="default"
                placement="bottomEnd"
                size="lg"
                ranges={predefinedBottomRanges}
                placeholder="From - To"
                style={{ width: 270, padding: 10 }}
                onClean={(e) => cleaningrange(e)}
                onChange={(e) => {
                  // if (e != null) {
                  //   setrange([]);
                  //   e.forEach((newValue) => {
                  //     var tzoffset = new Date().getTimezoneOffset() * 60000; //offset in milliseconds
                  //     var localISOTime = new Date(newValue - tzoffset)
                  //       .toISOString()
                  //       .slice(0, -1);
                  //     // "validtill",
                  //     handlechangedate(localISOTime);
                  //   });
                  // }
                }}
              />
            </div>
          </div> */}
        </div>

        <div
          style={{
            padding: " 0px 40px",
            // marginTop: "-13px",
            marginBottom: "20px",
          }}
        >
          <ReactTable
            data={
              state.UserSelectedDashboArdEmployeesgetdatas
                .UserOptionsDashboardEmplpyee
            }
            columns={columns}
            totalItems={
              state.UserSelectedDashboArdEmployeesgetdatas.Total_Count
            }
            currentPage={currentPage}
            onChange={tochange}
            setCurrentPage={setCurrentPage}
            pagesize={pagesize}
            dtpagesize={pageSize}
            dtpageindex={dtpageindex}
            pageindex={pageindex}
            datacount={state.UserSelectedDashboArdEmployeesgetdatas.Total_Count}
            MakeCreate={false}
            setsno={setsno}
            sno={sno}
            id={"spe"}
            onPrevious={handlePrevious}
            onNextpage={handleNext}
            GotoEnteredPage={GotoEnteredPage}
            Filter={true}
            NoFilter={true}
          />
        </div>
      </div>
    </>
  );
};

export default UserEmployeeList;
